
export interface AlmeAppConfig {
    lastEntryIdInterval: number;
    notificationApi: {
        pollForNotifications: boolean;
        pollForLiveChat: boolean;
        notificationInterval: number;
        liveChatInterval: {
            connected: number;
            disconnected: number;
        };
    };
    revision: number;
}

/**
 * This is the baseline alme app config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeAppConfig = {
    lastEntryIdInterval: 10000,
    notificationApi: {
        pollForNotifications: false,
        pollForLiveChat: false,
        notificationInterval: 10000,
        liveChatInterval: {
            connected: 2000,
            disconnected: 30000,
        },
    },
    revision: 0,
};

export default defaultConfig;